import Loadable from 'components/Loadable';
import RestrictedLayout from 'layout/RestrictedLayout';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router';

const RestrictedChangePassword = Loadable(lazy(() => import('pages/main/restricted/changePassword')));

const RestrictedInAppRoutes = <Route path='/*' element={<RestrictedLayout />}>
  <Route path='changePassword' element={<RestrictedChangePassword />} />
  <Route path='*' element={<Navigate replace to={'/changePassword'} />} />
</Route>

export default RestrictedInAppRoutes;